module.exports = __webpack_public_path__ + "img/S.c6f45f27.png";